import { useAppData } from "@danishagro/shared/src/contexts/appData.context";

export const useWebsiteType = (styles?: { [key: string]: string }) => {
    const { siteVariant } = useAppData();

    const websiteTypeClass =
        siteVariant.alias && styles ? styles[`is_${siteVariant.alias}`] : undefined;

    return {
        websiteType: siteVariant.alias,
        websiteTypeClass,
    };
};
